import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import Link from 'components/shared/link';
import Logo from 'images/logo.inline.svg';
import filterNonRootItems from 'utils/filter-non-root-items';
import MainContext from 'context/main';
import MenuItem from './menu-item';
import SocialItem from './social-item';

import styles from './footer.module.scss';

const cx = classNames.bind(styles);

const Footer = ({ theme }) => {
  const {
    menus: {
      footer: {
        menuItems: { nodes: menuItemsNodes },
      },
    },
    globalFields: {
      address,
      copyright,
      facebookUrl,
      instagramUrl,
      linkedinUrl,
      twitterUrl,
      youtubeUrl,
    },
  } = useContext(MainContext);

  // Graphql does not allow to filter by null values so has to do it manually
  const menuItems = filterNonRootItems(menuItemsNodes);

  const currentYear = new Date().getFullYear();
  const copyrightText = `© ${currentYear} ${copyright}`;

  return (
    <footer className={cx('wrapper', theme)}>
      <div className="container">
        <div className={cx('logo-wrapper')}>
          <Link className={cx('logo-link')} to="/">
            <Logo />
          </Link>
        </div>

        <div className={cx('menu')}>
          {menuItems.map((menuItem, index) => (
            <MenuItem label={menuItem.label} childItems={menuItem.childItems.nodes} key={index} />
          ))}
        </div>
        <div className={cx('wrapper-bottom')}>
          <div className={cx('copyright-wrapper')}>
            <span className={cx('copyright')}>{copyrightText}</span>
            <span className={cx('address')}>{address}</span>
          </div>
          <div className={cx('social')}>
            <SocialItem url={facebookUrl} iconName="facebook" />
            <SocialItem url={twitterUrl} iconName="twitter" />
            <SocialItem url={instagramUrl} iconName="instagram" />
            <SocialItem url={linkedinUrl} iconName="linkedin" />
            <SocialItem url={youtubeUrl} iconName="youtube" />
          </div>
        </div>
      </div>
    </footer>
  );
};

Footer.defaultProps = {
  theme: null,
};

Footer.propTypes = {
  theme: PropTypes.oneOf(['default', 'with-border']),
};

export default Footer;
